import * as S from './SwipeStack.styles';
export const SwipeStack = S.Root;